import { Card, styled } from "@mui/material";

export const StyledCalendarCard = styled(Card)(({ theme }) => ({
  minWidth: 0,
  overflow: "hidden",
  "& .fc": {
    "--fc-border-color": theme.palette.divider,
    "--fc-page-bg-color": theme.palette.background.paper,
    "--fc-neutral-bg-color": theme.palette.action.hover,
    "--fc-neutral-text-color": theme.palette.text.secondary,
    "--fc-today-bg-color": theme.palette.action.selected,
    color: theme.palette.text.primary,
  },
  "& .fc .fc-view-harness, & .fc .fc-scroller-harness": {
    minWidth: 0,
    maxWidth: "100%",
  },
  "& .fc-toolbar-title": {
    color: theme.palette.text.primary,
    fontSize: "2rem",
    fontWeight: 700,
  },
  "& .fc-button-primary": {
    backgroundColor: `${theme.palette.primary.main} !important`,
    borderRadius: "12px !important",
    borderColor: `${theme.palette.primary.main} !important`,
    lineHeight: "1.75 !important",
    fontSize: "0.875rem !important",
    margin: "0 5px 0 0 !important",
    paddingInline: "12px !important",
  },
  "& .fc-button-primary:hover": {
    backgroundColor: `${theme.palette.primary.dark} !important`,
    boxShadow: "none !important",
  },
  "& .fc-button-primary:focus": {
    backgroundColor: `${theme.palette.primary.dark} !important`,
    boxShadow: "none !important",
  },
  "& .fc-button-primary:disabled": {
    opacity: "0.55",
  },
  "& .fc-daygrid-day-number, & .fc-col-header-cell-cushion": {
    color: `${theme.palette.text.secondary} !important`,
  },
  "& .fc-day-today.fc-daygrid-day": {
    background: `${theme.palette.action.selected} !important`,
  },
  "& .fc-day-today div div .fc-daygrid-day-number": {
    fontWeight: "700 !important",
    backgroundColor: `${theme.palette.primary.main} !important`,
    borderRadius: "8px",
    color: `${theme.palette.common.white} !important`,
    padding: "2px 8px",
  },
  "& .fc-theme-standard td, & .fc-theme-standard th": {
    borderColor: `${theme.palette.divider} !important`,
  },
  "& .fc-theme-standard .fc-scrollgrid": {
    borderColor: `${theme.palette.divider} !important`,
    borderRadius: "12px",
    overflow: "hidden",
  },
  "& .fc-theme-standard .fc-list": {
    borderColor: `${theme.palette.divider} !important`,
  },
  "& .fc .fc-scrollgrid-section > td": {
    borderColor: `${theme.palette.divider} !important`,
  },
  "& .fc .fc-timegrid-slot, & .fc .fc-timegrid-axis, & .fc .fc-timegrid-col": {
    borderColor: `${theme.palette.divider} !important`,
  },
  "& .fc .fc-col-header-cell, & .fc .fc-daygrid-day": {
    borderColor: `${theme.palette.divider} !important`,
  },
  "& .fc-more-popover": {
    borderRadius: "12px",
    borderColor: `${theme.palette.divider}`,
    backgroundColor: `${theme.palette.background.paper}`,
  },
  "& .fc-more-popover .fc-popover-header": {
    backgroundColor: `${theme.palette.primary.main} !important`,
  },
  "& .fc-more-popover .fc-popover-header .fc-popover-title": {
    color: `${theme.palette.common.white} !important`,
    fontWeight: "500 !important",
  },
  "& .fc-more-popover .fc-popover-header .fc-popover-close": {
    color: `${theme.palette.common.white} !important`,
  },
  "& .default-schedule-event": {
    overflow: "hidden !important",
    textOverflow: "ellipsis !important",
    display: "block",
  },
  "& .default-schedule-event b": {
    margin: "0 4px !important",
  },
  [theme.breakpoints.down("md")]: {
    "& .fc .fc-toolbar": {
      alignItems: "stretch",
      flexDirection: "column",
      gap: "10px",
    },
    "& .fc .fc-toolbar-chunk": {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      gap: "8px",
    },
    "& .fc .fc-toolbar-title": {
      fontSize: "1.8rem",
      textAlign: "center",
      width: "100%",
    },
    "& .fc .fc-button-group": {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      gap: "8px",
    },
    "& .fc .fc-button-group > .fc-button": {
      margin: "0 !important",
    },
  },
  [theme.breakpoints.down("sm")]: {
    "& .fc .fc-toolbar-title": {
      fontSize: "1.45rem",
      lineHeight: 1.25,
    },
    "& .fc .fc-toolbar.fc-header-toolbar": {
      marginBottom: "12px",
    },
    "& .fc .fc-toolbar.fc-footer-toolbar": {
      marginTop: "12px",
    },
    "& .fc .fc-button-primary": {
      minHeight: "40px",
      paddingInline: "10px !important",
    },
    "& .fc .fc-col-header-cell-cushion": {
      fontSize: "0.9rem",
      padding: "8px 2px",
    },
  },
}));
